import type { ReactNode } from 'react'
import './Banner.css'

export type BannerTone = 'promo' | 'dark'

export interface BannerProps {
  tone?: BannerTone
  icon?: ReactNode
  onClose?: () => void
  children: ReactNode
}

/** Dismissible full-width announcement bar. */
export function Banner({ tone = 'promo', icon, onClose, children }: BannerProps) {
  return (
    <div className={`azoya-banner azoya-banner--${tone}`}>
      {icon && <span className="azoya-banner-icon">{icon}</span>}
      <p className="azoya-banner-text">{children}</p>
      {onClose && (
        <button className="azoya-banner-close" aria-label="Fermer" onClick={onClose}>
          ×
        </button>
      )}
    </div>
  )
}
